import { useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import { useAdminAuth } from "../context/AdminAuthContext"
import Swal from "sweetalert2"

import { API_BASE } from "../config/api"

function Login() {
    const navigate = useNavigate();
    const { fetchMe } = useAdminAuth();
    const [identifier, setIdentifier] = useState(""); // correo o usuario
    const [password, setPassword] = useState("");
    const [remember, setRemember] = useState(true);
    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        if (loading) return;

        setLoading(true);
        try {
        const res = await fetch(`${API_BASE}/api/admin/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include", // ✅ cookies
            body: JSON.stringify({ identifier, password, remember }),
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok || !data.ok) {
            const code = data.code;

            if (code === "USER_INACTIVE") {
            await Swal.fire({
                icon: "info",
                title: "Usuario no activado",
                text: data.message || "Tu usuario no está activado. Consulta con el administrador.",
            });
            return;
            }

            if (code === "NOT_ADMIN") {
            await Swal.fire({
                icon: "warning",
                title: "Sin permisos",
                text: data.message || "No tienes permisos de administrador.",
            });
            return;
            }

            await Swal.fire({
            icon: "error",
            title: "Error",
            text: data.message || "Credenciales inválidas.",
            });
            return;
        }
        await fetchMe();
        // ✅ login OK (cookies seteadas)
        navigate("/", { replace: true });
        } catch (err) {
        await Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo conectar con el servidor.",
        });
        } finally {
        setLoading(false);
        }
    }

    return (
        <div class="wrapper">
            <section class="login-content">
                <div class="row m-0 align-items-center bg-white h-100">
                    <div class="col-md-6">
                    <div class="row justify-content-center">
                        <div class="col-md-10">
                            <div class="card card-transparent shadow-none d-flex justify-content-center mb-0 auth-card iq-auth-form">
                                <div class="card-body">
                                <a href="/login" class="navbar-brand d-flex align-items-center justify-content-center mb-3">
                                    <div class="logo-main">
                                        <div class="logo-normal">
                                            <img src="./assets/images/icon-core.svg" class="img-fluid" alt="images" loading="lazy" style={{width:'35px'}} />
                                        </div>
                                        <div class="logo-mini">
                                            <img src="./assets/images/icon-core.svg" class="img-fluid" alt="images" loading="lazy" style={{width:'30px'}} />
                                        </div>
                                    </div>
                                    <h4 class="logo-title ms-3 mb-0" data-setting="app_name">Panduit Core</h4>
                                </a>
                                <h2 class="mb-2 text-center">Login</h2>
                                <form onSubmit={handleSubmit}>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group">
                                            <label for="email" class="form-label">Usuario o Correo</label>
                                            <input
                                            type="text"
                                            className="form-control"
                                            id="identifier"
                                            placeholder=" "
                                            value={identifier}
                                            onChange={(e) => setIdentifier(e.target.value)}
                                            required
                                            />
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="form-group">
                                            <label for="password" class="form-label">Password</label>
                                            <input
                                            type="password"
                                            className="form-control"
                                            id="password"
                                            placeholder=" "
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                            />
                                            </div>
                                        </div>
                                        <div class="col-lg-12 d-flex justify-content-between">
                                            <div class="form-check mb-3">
                                            <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="rememberme"
                                            checked={remember}
                                            onChange={(e) => setRemember(e.target.checked)}
                                            />
                                            <label class="form-check-label" for="customCheck1">Recuerdame</label>
                                            </div>
                                            {/* <a href="/forgot-password">Forgot Password?</a> */}
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? "Iniciando..." : "Iniciar sesión"}
                                        </button>
                                    </div>
                                    {/* <p class="mt-3 text-center">
                                        Don’t have an account? <a href="/register" class="text-underline">Click here to sign up.</a>
                                    </p> */}
                                </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="col-md-6 d-md-block d-none bg-primary p-0 vh-100 overflow-hidden">
                    <img src="../../assets/images/auth/Gráfico-admin-core.jpg" class="img-fluid gradient-main animated-scaleX" alt="images" loading="lazy" />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Login